/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailSocialUploadsQueryResponse, WebAppGetCompositionsDetailSocialUploadsPathParams, WebAppGetCompositionsDetailSocialUploads401, WebAppGetCompositionsDetailSocialUploads403 } from "../models/WebAppGetCompositionsDetailSocialUploads";

export function getWebAppGetCompositionsDetailSocialUploadsUrl(id: WebAppGetCompositionsDetailSocialUploadsPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/compositions/${id}/social-uploads` as const }
  return res
}

/**
 * @summary List social uploads for a composition
 * {@link /web-app/v1/compositions/:id/social-uploads}
 */
export async function webAppGetCompositionsDetailSocialUploads(id: WebAppGetCompositionsDetailSocialUploadsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailSocialUploads401 | WebAppGetCompositionsDetailSocialUploads403>, unknown>({ method : "GET", url : getWebAppGetCompositionsDetailSocialUploadsUrl(id).url.toString(), ... requestConfig })
  return res.data
}